<div class="property toggle">
  <ax-icon
    *ngIf="showIcon"
    class="icon type-icon"
    [name]="customIcon ? customIcon : 'toggle-switch'"
  ></ax-icon>
  <mat-slide-toggle
    [required]="required"
    [ngClass]="{readonly: readonly}"
    [formControl]="toggleControl"
  >
    {{ label }} <span *ngIf="required">&nbsp;*</span>
  </mat-slide-toggle>

  <div class="hint-wrapper">
    <mat-hint class="hint" align="end" *ngIf="form.valid || form.untouched || form.disabled">
      {{ hint }}
    </mat-hint>
    <ax-property-error *ngIf="form.touched" [form]="form" [label]="label"></ax-property-error>
  </div>
</div>
